// Module
var code = `<div class="login-screen">
    <div class="login-screen-box-container">
        <terceraPictureBox imageUrl="{{.pictureUrl}}" component_style="js-login-banner-picture-box" visible="{{!!.pictureUrl}}" />

        {{#if .connectionInfoMenuItems.length > 1 && inputMode}}
            <reactCombobox  isComboboxItemMode="true"
                            options="{{.connectionInfoMenuItems}}"
                            value="{{.selectedConnectionInfoMenuItem}}"
                            disabled="{{.isLoginDisabled}}"
                            on-onValueChange="@this.onConnectionSelected(\$1)" />
        {{/if}}

        <terceraTextBox visible="{{inputMode&&AllowCustomerNo}}"
                        name="tbLoginCustomerNo"
                        haveError="{{.needCustomerNo}}"
                        text="{{.connectionParams.customerNo}}"
                        enabled="{{.loginEnabled}}"
                        tooltip="{{.tooltipCustomerNo}}"
                        placeholder="{{.placeholderCustomerNo}}"
                        autofocus="true"
                        elementStyle="js-input-container-login" />

        <terceraTextBox visible="{{inputMode}}"
                        name="tbLogin"
                        haveError="{{.needLogin}}"
                        text="{{.connectionParams.login}}"
                        enabled="{{.loginEnabled}}"
                        tooltip="{{.tooltipLogin}}"
                        placeholder="{{.placeholderLogin}}"
                        autofocus="true"
                        elementStyle="js-input-container-login"
                        maxLength="320" />

        <passwordTextBox visible="{{inputMode}}"
                        name="tbPwd"
                        showPasswordPreview="{{.selectedConnectionInfoMenuItem.value.allowPasswordPreview && !.savePasswordCheckedFromConnectionSettings}}"
                        haveError="{{.needPassword}}"
                        text="{{.connectionParams.pass}}"
                        focused="{{passwordTextBoxFocused}}"
                        enabled="{{.loginEnabled}}"
                        tooltip="{{.tooltipPassword}}"
                        placeholder="{{.placeholderPassword}}"
                        elementStyle="js-input-container-login" />

        {{#if selectedConnectionInfoMenuItem.value.allowSavePassword}}
        <reactFormLabel label="{{.savePassText}}" labelColor="{{savePassTextColor}}">
            <reactCheckbox
                checked="{{savePasswordChecked}}"
                on-onChange="@this.onSavePasswordCheckedChanged(\$1)"
            />
        </reactFormLabel>
        {{/if}} 

        {{#if .login_language_selector}}
        <terceraComboBox elementStyle="js-combobox-login"
                         selectedItem="{{.selectedlangItem}}"
                         items="{{.langItems}}"
                         enabled="{{.loginEnabled}}" />
        {{/if}}
    </div>

    <div class="login-screen-linkBtn-container">
        <terceraButton name="loginBtn"
                       terceraButtonStyle="js-button-ok{{ connectionParams.pass === '' || connectionParams.login === '' ? ' disabled' : '' }}"
                       text="{{.textButton}}"
                       tooltip="{{.tooltipLoginBtn}}"
                       enabled="{{.loginEnabled}}"
                       visible="{{inputMode}}"
                       showDisabledToolTip="false" />

        {{#if .thirdPartyProviderLoginButtonText}}
            <terceraButton name="thirdPartyLoginBtn"
                        terceraButtonStyle="js-button-ok"
                        text="{{.thirdPartyProviderLoginButtonText}}"
                        enabled="{{.loginEnabled}}"
                        on-btnClick="onThirdPartyLoginBtnClick"/>
        {{/if}}

        {{#if .thirdPartyProviderLoginLinkText}}
            <terceraLinkLabel text="{{.thirdPartyProviderLoginLinkText}}" name="thirdPartyLoginLink" on-linkClick="onThirdPartyLoginLinkClick"/>
        {{/if}}

        {{#if .thirdPartyProviderCertificateLinkText}}
            <terceraLinkLabel text="{{.thirdPartyProviderCertificateLinkText}}" name="caInfoLink" on-linkClick="onThirdPartyCetificateInfoLinkClick"/>
        {{/if}}

        {{#if .selectedConnectionInfoMenuItem}}
            <terceraLinkLabel text="{{.textRecover}}"
                tooltip="{{.tooltipRecover}}"
                name="lblRecoveryLink"
                on-linkClick="recoverClick"
                visible="{{.forgotPasswordVisible}}" />

            <terceraLinkLabel text="{{.textExplore}}" 
                tooltip="{{.tooltipExplore}}" 
                name="lblExploreLink"
                on-linkClick="exploreClick"
                visible="{{.allowExplore && inputMode}}"/>
            
            {{#if loginPromptText}}
                <terceraLabel text="{{loginPromptText}}" additionalClass="login-prompt-text"/>
            {{/if}}

            <linkLabelContainer name="lblDemoLinks" links="{{.connectionParams.registrationLinks}}" tooltips="{{.tooltipsForDemoRegLinks}}" visible="{{.createDemoAccountAllowed && .ICFRPL}}" />
        {{/if}}

        {{#if .chatLinkTop}}
        <terceraLinkLabel name="lblChatLink"
                          text="{{.chatLinkText}}"
                          linkHref="{{.connectionParams.chatLink}}"
                          visible="{{.connectionParams.chatLink}}" />
        {{/if}}

        <terceraMultiLineLabel text="{{.textErrorLabel}}" tooltip="{{.textErrorLabel}}" />
    </div>
</div>`;
// Exports
export default code;